import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getSession } from "../lib/api.js";

const BENEFITS = [
  {
    icon: "🗓",
    title: "Бронь за пару касаний",
    body: "Мастер /book с кнопками: аэродром → класс → день → длительность → время. Без сообщений админу и созвонов.",
  },
  {
    icon: "✈️",
    title: "Никаких пересечений",
    body: "F3A — в небе один. F9U — лимит ёмкости настраивает админ. Бот показывает только те окна, куда вы реально влезаете.",
  },
  {
    icon: "⏱",
    title: "Отмена до 1 часа",
    body: "Передумали? Отмените сами через /myslots — без объяснений и без штрафов. Меньше часа — пишите админу.",
  },
  {
    icon: "🛠",
    title: "Гараж и документы",
    body: "Загрузите страховку, сертификаты и фото моделей один раз. Админу видно, что у вас всё в порядке.",
  },
  {
    icon: "🔔",
    title: "Напоминания и анонсы",
    body: "Бот напомнит о слоте за час, пришлёт объявление админа и предупредит, если погода или режим аэродрома изменились.",
  },
  {
    icon: "📋",
    title: "Прозрачно для админа",
    body: "Расписание, члены, предупреждения, аудит — всё через /admin. Не нужно вести таблицу в чате.",
  },
];

const STEPS = [
  {
    n: 1,
    title: "Откройте бота",
    body: (
      <>
        В Telegram найдите{" "}
        <a href="https://t.me/rcflyers_bot" target="_blank" rel="noopener noreferrer">
          @rcflyers_bot
        </a>{" "}
        и нажмите <b>Start</b> (или отправьте <code>/start</code>).
      </>
    ),
  },
  {
    n: 2,
    title: "Получите свой Telegram ID",
    body: (
      <>
        После <code>/start</code> бот пришлёт ваш ID отдельным сообщением. Если уже регистрировались — спросите его в любой момент через <code>/whoami</code>.
      </>
    ),
  },
  {
    n: 3,
    title: "Перешлите ID админу аэродрома",
    body: (
      <>
        Админ добавит вас в члены аэродрома командой <code>/airfield_member_add</code>. Без этого <code>/book</code> не сработает — это защита от чужих броней.
      </>
    ),
  },
  {
    n: 4,
    title: "Бронируйте",
    body: (
      <>
        Команда <code>/book</code> или меню — бот покажет ближайшие свободные окна. Подтвердите ✅ — слот ваш.
      </>
    ),
  },
];

export default function Welcome() {
  const navigate = useNavigate();
  const [hasSession, setHasSession] = useState(false);

  useEffect(() => {
    setHasSession(Boolean(getSession()));
  }, []);

  return (
    <div className="rcf-welcome">
      <header className="rcf-welcome__hero">
        <div className="rcf-welcome__eyebrow">RCFlyers</div>
        <h1 className="rcf-welcome__title">
          Бронирование полётов на RC-аэродроме
          <span> прямо в Telegram</span>
        </h1>
        <p className="rcf-welcome__lede">
          Слоты по классам, без пересечений, с гаражом моделей и документами пилота. Без таблиц в чате и переписки «свободно ли в 17:00».
        </p>
        <div className="rcf-welcome__cta">
          <a
            className="rcf-welcome__btn rcf-welcome__btn--primary"
            href="https://t.me/rcflyers_bot"
            target="_blank"
            rel="noopener noreferrer"
          >
            Открыть @rcflyers_bot
          </a>
          {hasSession ? (
            <button
              type="button"
              className="rcf-welcome__btn rcf-welcome__btn--ghost"
              onClick={() => navigate("/", { replace: true })}
            >
              Перейти в кабинет
            </button>
          ) : (
            <Link to="/login" className="rcf-welcome__btn rcf-welcome__btn--ghost">
              Войти в веб-версию
            </Link>
          )}
        </div>
        <div className="rcf-welcome__meta">
          Бесплатно для пилотов · Telegram-логин · данные хранятся в РФ (152-ФЗ)
        </div>
      </header>

      <section className="rcf-welcome__section">
        <h2 className="rcf-welcome__h2">Зачем</h2>
        <div className="rcf-welcome__grid">
          {BENEFITS.map((b) => (
            <div className="rcf-welcome__card" key={b.title}>
              <div className="rcf-welcome__card-icon">{b.icon}</div>
              <div className="rcf-welcome__card-title">{b.title}</div>
              <div className="rcf-welcome__card-body">{b.body}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="rcf-welcome__section">
        <h2 className="rcf-welcome__h2">Как зарегистрироваться</h2>
        <ol className="rcf-welcome__steps">
          {STEPS.map((s) => (
            <li className="rcf-welcome__step" key={s.n}>
              <div className="rcf-welcome__step-n">{s.n}</div>
              <div className="rcf-welcome__step-body">
                <div className="rcf-welcome__step-title">{s.title}</div>
                <div className="rcf-welcome__step-text">{s.body}</div>
              </div>
            </li>
          ))}
        </ol>
        <div className="rcf-welcome__note">
          Ведёте свой аэродром и хотите подключить его? Напишите суперадмину — он создаст площадку и назначит вас её администратором.
        </div>
      </section>

      <footer className="rcf-welcome__footer">
        <div>RCFlyers · некоммерческий проект для RC-сообщества</div>
        <div>
          <a href="https://t.me/rcflyers_bot" target="_blank" rel="noopener noreferrer">
            Telegram-бот
          </a>
          {" · "}
          <Link to="/login">Веб-вход</Link>
        </div>
      </footer>
    </div>
  );
}
